import React from "react";
import { Text, View } from "react-native";
import FileIcon from "@/assets/svgs/file-icon";

function ResourcesEmptyState() {
  return (
    <View className="mx-5 gap-6">
      <View className="items-center pt-4">
        <FileIcon
          className="size-16"
          pathClassName="stroke-teachLoop-textPrimary"
        />
      </View>
      <View className="px-4 py-10 bg-teachLoop-creamDark rounded-2xl">
        <Text className="font-geologica-regular text-center text-base text-gray-800 leading-[1.5]">
          No resources are available yet. Check back later for guides and
          helpful documents.
        </Text>
      </View>
    </View>
  );
}

export default ResourcesEmptyState;
